<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  mounted() {

  },
  methods: {
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    },

    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '信号源賬戶', field: 'customerNumber' },
          { title: '開始時間', field: 'startTime', type: 5 },
          { title: '結束時間', field: 'endTime', type: 5 },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.sourceLogList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: 'accountId', field: 'accountId' },
          { title: '信号源交易账号', field: 'customerNumber' },
          { title: '指派给公司', field: 'assigningCompanyId' },
          { title: '指派给业务', field: 'assigningBusinessType' },
          { title: '操作人', field: 'operator' },
          {
            title: '时间', field: 'operateTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '操作類型', field: 'dataType' },
          { title: '操作內容', field: 'dataMsg' }
        ]
      }
    }
  }
}
</script>
